export default __webpack_public_path__ + "static/media/DistanceBetweenPileAxis.c4288974.png";